<template>
  <esg-base-dashboard-card v-if="data"
                           title="평가 그레이드 비율">
    <template #actions>
      <b-col>
        <b-row>
          <b-form-select v-model="target"
                         size="sm">
            <option :value="'all'">ALL</option>
            <option v-for="option in rawData"
                    :key="option.assessmentElementDesc"
                    :value="option.assessmentElementDesc">
              {{ `${option.assessmentElement[0]}-${option.assessmentElementDesc}` }}
            </option>
          </b-form-select>
        </b-row>
      </b-col>
    </template>
    <esg-base-chart height="300px">
      <apex-chart v-if="data"
                  ref="ref"
                  type="donut"
                  height="300px"
                  :options="chartOptions"
                  :series="series"/>
    </esg-base-chart>
  </esg-base-dashboard-card>
</template>
<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  name: 'CT00036',
  components: {EsgBaseChart, EsgBaseDashboardCard},
  props: ['data', 'clickable'],
  data() {
    return {
      series: [],
      target: 'all',
      chartOptions: {
        chart: {
          type: 'donut',
          events: {
            dataPointSelection: function (event, chartContext, config) {
              this.selected(config.dataPointIndex);
            }
          }
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: (val, opts) => {
              let percentage = val / opts.config.series.reduce((sum, current) => sum + current, 0) * 100
              return `${this.formatNumber(val, 0)}개 사 [ ${this.formatNumber(percentage, 0)}% ]`
            },
          },
        },
        legend: {
          position: 'bottom',
        },
        dataLabels: {
          enabled: false, //=> 데이터 series값 출력
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                value: {
                  show: true,
                  formatter: val => Number(val).toLocaleString('ko-KR') + '개 사'
                },
                total: {
                  show: true,
                  label: 'Total',
                  color: '#000000',
                  formatter: chart => chart.config.series.reduce((sum, current) => sum + current, 0).toLocaleString('ko-KR') + '개 사'
                },
              },
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {width: 300},
              legend: {position: 'bottom'}
            }
          },
        ],
      },
      rawData: [
        {
          assessmentElement: "Environment",
          assessmentElementDesc: "환경",
          leader: 12,
          average: 104,
          lagged: 133,
          fileUrl: 'test'
        },
        {
          assessmentElement: "Social",
          assessmentElementDesc: "안전",
          leader: 12,
          average: 100,
          lagged: 137,
          fileUrl: 'test'
        },
        {
          assessmentElement: "Social",
          assessmentElementDesc: "사회",
          leader: 10,
          average: 139,
          lagged: 100,
          fileUrl: 'test'
        },
        {
          assessmentElement: "Social",
          assessmentElementDesc: "윤리",
          leader: 8,
          average: 134,
          lagged: 107,
          fileUrl: 'test'
        },
        {
          assessmentElement: "Governance",
          assessmentElementDesc: "경제",
          leader: 12,
          average: 134,
          lagged: 103,
          fileUrl: 'test'
        },
        {
          assessmentElement: "Governance",
          assessmentElementDesc: "경영시스템",
          leader: 5,
          average: 130,
          lagged: 114,
          fileUrl: 'test'
        }
      ],
    }
  },
  created() {
    this.chartOptions.labels = ['Leader', 'Average', 'Laggard']
    this.setSeries();
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.setSeries();
        this.refreshChart();
      }
    },
    target: {
      deep: true,
      handler() {
        this.setSeries();
        this.refreshChart();
      }
    }
  },
  methods: {
    async setSeries() {
      // 시각화 데이터 추출
      if (this.target !== 'all') {
        let targetData = this.rawData.filter(obj => obj.assessmentElementDesc === this.target)[0]
        this.series.splice(0)
        this.series.unshift(targetData.leader)
        this.series.unshift(targetData.average)
        this.series.unshift(targetData.lagged)
      } else {
        this.series = [ 103, 134, 12 ]
        // let targetData = {
        //   leader: 0,
        //   average: 0,
        //   lagged: 0,
        // }
        // this.rawData.forEach(data => {
        //   targetData.leader += data.leader;
        //   targetData.average += data.average;
        //   targetData.lagged += data.lagged;
        // })
        // this.series.splice(0)
        // this.series.unshift(targetData.lagged)
        // this.series.unshift(targetData.average)
        // this.series.unshift(targetData.leader)
      }
    },
  }
}
</script>
